import React from 'react'
import { useRouteMatch, useLocation, useHistory } from 'react-router-dom'
import Badge from '@material-ui/core/Badge'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { PageHeader } from 'components/page-header'
import { Tabs, Tab } from 'components/tabs'
import LeadsQuery from './leads-query'
import { useGetLeads } from './api-hooks'
import { ReactComponent as AutoRespondersIcon } from 'images/icons/auto-responders.svg'

const useStyles = makeStyles(theme => ({
  newTabBadge: {
    '& .MuiBadge-badge': {
      right: '3rem',
      transform: 'unset',
      backgroundColor: '#f44336',
      [theme.breakpoints.only('xs')]: {
        right: 0,
      },
    },
  },
}))

const LeadsPage = React.memo(({ setUnviewedLeadCount }) => {
  const { path } = useRouteMatch()
  const location = useLocation()
  const history = useHistory()
  const classes = useStyles()

  const {
    loading: leadsLoading,
    error: leadsError,
    data: leadsData,
    refetch: leadsRefetch,
  } = useGetLeads()

  const unviewedLeadsCount =
    leadsData &&
    leadsData.coachingInquiries?.filter(lead => lead.viewedAt === null).length
  const queryParams = new URLSearchParams(location.search)
  const tabValue = queryParams.get('tab') === 'contacted' ? 'contacted' : 'new'

  const handleTabChange = (_, newValue) => {
    if (newValue === tabValue) {
      return
    }
    history.push(`${path}?tab=${newValue}`)
  }

  const tabs = (
    <Tabs value={tabValue} onChange={handleTabChange}>
      <Tab
        label={
          <Badge
            color="error"
            badgeContent={unviewedLeadsCount}
            invisible={unviewedLeadsCount === 0}
            className={classes.newTabBadge}
          >
            <span>New</span>
          </Badge>
        }
        value="new"
      />
      <Tab label="Contacted" value="contacted" />
    </Tabs>
  )

  const actions = (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<AutoRespondersIcon style={{ width: 20, height: 20 }} />}
      onClick={() => history.push('/pga-coach/settings/leads-auto-reply')}
    >
      Lead Auto-Reply
    </Button>
  )

  return (
    <>
      <PageHeader
        title="Leads"
        tabs={tabs}
        actions={actions}
        fixedMobileActions
      />
      <LeadsQuery
        {...{
          data: leadsData?.coachingInquiries,
          coachingLeadContactMethodOptions:
            leadsData?.coachingLeadContactMethodOptions ?? [],
          freeTierLimitsReached:
            leadsData?.currentUser?.attributes?.freeTierLimitsReached,
          error: leadsError,
          loading: leadsLoading,
          refetch: leadsRefetch,
          setUnviewedLeadCount,
          tab: tabValue,
        }}
      />
    </>
  )
})

export default LeadsPage
